export default {
  API_ENDPOINT: 'https://noteful-api-19196.herokuapp.com/api'
}
